import { useEffect, useState } from "react"
import Content from "../../../components/Content"
import { useAppSelector } from "../../../store/store"
import { getTeamContracts } from "../../../services/team.services"
import ContractInterface from "../../../interfaces/Contract.interface"
import NewContractForm from "./NewContract"
import TeamContract from "../../../components/TeamContract"

const ContractsPage = () => {
    const team = useAppSelector(state => state.team)
    const token = useAppSelector(state => state.token)
    const player = useAppSelector(state => state.player)
    const isMember = player.teams?.find((member) => member.team_id === team.id)

    const [contracts, setContracts] = useState<ContractInterface[]>([])

    useEffect(() => {
        getTeamContracts({ teamId: team.id as string, token: token || "" })
            .then((res) => {
                setContracts(res.data.payload.contracts)
            })
    }, [])

    if (!isMember?.admin) return (
        <Content>
            <p className="text-5xl text-zinc-700 text-center">Área restringida para vos.</p>
        </Content>
    )


    return (
        <Content className="flex flex-col gap-5">
            <div className="flex justify-between items-center">
                <p className="text-zinc-700 text-2xl">Contratos</p>
                <NewContractForm />
            </div>
            {contracts.length > 0 ?
                contracts.map(contract => (
                    <TeamContract key={contract.id} contract={contract} />
                ))
                :
                <p>No hay ningún contrato aún</p>
            }
        </Content>
    )
}

export default ContractsPage